import React, { Fragment } from "react"
import * as dateHelper from "../../helpers/date"
import config from "react-global-configuration"
import { getCssLegend } from "../../helpers/bookingHelper"
import useWindowWidth from "../../../hooks/useWindowWidth"

export default function CheckoutExtendBookings(props) {
  const windowWidth = useWindowWidth()

  const getDate = (date) => {
    const day = dateHelper.formatDate(date, "dddd")
    const formattedDay = day.charAt(0).toUpperCase() + day.slice(1)
    const formattedDate = dateHelper.formatDate(date, "DD/MM/YYYY")
    return `${formattedDay} ${formattedDate}`
  }

  if (!props.bookingExtension) return null
  if (!props.changeFromBooking) return null

  const { booking, parkingExtension, bookingSummary } = props.bookingExtension
  const { parking: cfParking, booking: cfBooking } = props.changeFromBooking
  const carPark = props.bookingExtension.carParks[0]
  const product = props.bookingExtension.products[0]
  const textKeys = config.get("textKeys.checkout.compare") || {}

  const legend = getCssLegend(props.bookingExtension.carParks[0].name, props.bookingExtension.carParks[0].name)

  const thirdPartyPromoLabel = booking?.thirdPartyPromoLabelText
  const cfThirdPartyPromoLabel = cfBooking?.thirdPartyPromoLabelText

  let changeFromMembership = booking?.membershipNumber ? true : false
  let loggedInMembership = props.userAccountDetails?.CustomerNumber ? true : false
  let hasLoggedInInfo = loggedInMembership || changeFromMembership ? true : false
  let membershipCarParks = [77, 71]

  const previousBookingHasPromotionDiscount = !!cfBooking?.promotionCode && cfBooking?.promotionSaving > 0 ? true : false
  const previousBookingIsAffiliate =
    !!cfBooking?.affiliateCode && !cfBooking.useMemberPrice && cfParking?.amount < cfParking.originalAmount ? true : false

  const changeFromBookingPrice =
    cfBooking.useMemberPrice || previousBookingHasPromotionDiscount || previousBookingIsAffiliate || cfParking.isParkingUpgrade
      ? cfParking.amount
      : cfParking.originalAmount // prePay for previous booking - no extra products

  const bookingResultPrice =
    parkingExtension.prices[0].amount < changeFromBookingPrice && !parkingExtension.allowRefund
      ? changeFromBookingPrice
      : parkingExtension.prices[0].amount // if prePay is less than new booking and refund is not allowed, set new booking price to prePay price

  const totalpricedifference = bookingResultPrice - changeFromBookingPrice

  //promotion discount
  const bookingHasPromotionDiscount =
    !!props.bookingResult?.booking?.promotionCode && props.bookingResult?.booking?.promotionSaving > 0 ? true : false
  let bookingPromotionDiscountValue = 0
  //let promotionDiscountText = textKeys.promotionDiscount || "Totalbesparelse for denne ordre: {price} DKK"

  if (bookingHasPromotionDiscount)
    bookingPromotionDiscountValue = parkingExtension.prices[0]?.amount - parkingExtension.prices[0]?.originalAmount || 0

  //cph profile discount
  const hasActiveMembershipPrice = membershipCarParks.includes(carPark?.id) && hasLoggedInInfo
  let membershipBookingPriceDifference = 0
  //let membershipDiscountText = textKeys.membershipDiscount || "Totalbesparelse for denne ordre: {price} DKK"

  //CPH profile discount is 20%
  if (hasActiveMembershipPrice) membershipBookingPriceDifference = (bookingSummary.bookingValue - bookingSummary.bookingValue * 1.2).toFixed(2)

  return (
    <div className="form__section form__section--no-border">
      <section className="checkout-content">
        <section className="section-body first">
          <header className="amend-booking-header">
            <h1>
              <strong>{textKeys.currentBooking || "Booking forlængelse"}</strong>
            </h1>
          </header>
          <div className="drive-in">
            <p className="left">
              <strong>{textKeys.driveInDate || "Indkørselsdato"}</strong>
            </p>
            <p className="right">
              {getDate(booking.arrivalDate)} ({booking.arrivalTime})
            </p>
          </div>

          <div className="drive-out">
            <p className="left">
              <strong>{textKeys.driveOutDate || "Udkørselsdato"}</strong>
            </p>
            <p className="right">
              {getDate(parkingExtension.newDepartureDate)} ({parkingExtension.newDepartureTime})
            </p>
          </div>
          <hr />

          <div className={`parking-info ${thirdPartyPromoLabel ? "shows-promo-label" : ""}`}>
            <div className="parking-product-table__list__col parking-product-table__list__col--title">
              <div className="parking-legend__current parking-legend--list">
                <span className={`parking-legend__item parking-legend__item--${legend}`}>{carPark.name}</span>
              </div>
              {windowWidth > 450 ? (
                <h5>{`${product.name}${thirdPartyPromoLabel ? ` - ${thirdPartyPromoLabel}` : ""}`}</h5>
              ) : (
                <h5>
                  {product.name}
                  <br></br>
                  {thirdPartyPromoLabel ? thirdPartyPromoLabel : ""}
                </h5>
              )}
            </div>
            <p className="right">{props.priceFormatter(bookingResultPrice)}</p>
          </div>
        </section>

        <section className="section-body last">
          <header className="amend-booking-header">
            <h1>
              <strong>{textKeys.previousBooking || "Tidligere Booking"}</strong>
            </h1>
          </header>
          <div className="drive-in">
            <p className="left">
              <strong>{textKeys.driveInDate || "Indkørselsdato"}</strong>
            </p>
            <p className="right">
              {getDate(booking.arrivalDate)} ({booking.arrivalTime})
            </p>
          </div>

          <div className="drive-out">
            <p className="left">
              <strong>{textKeys.driveOutDate || "Udkørselsdato"}</strong>
            </p>
            <p className="right">
              {getDate(booking.departureDate)} ({booking.departureTime})
            </p>
          </div>
          <hr />

          <div className={`parking-info ${cfThirdPartyPromoLabel ? "shows-promo-label" : ""}`}>
            <div className="parking-product-table__list__col parking-product-table__list__col--title">
              <div className="parking-legend__current parking-legend--list">
                <span className={`parking-legend__item parking-legend__item--${legend}`}>{carPark.name}</span>
              </div>
              {windowWidth > 450 ? (
                <h5>{`${product.name}${cfThirdPartyPromoLabel ? ` - ${cfThirdPartyPromoLabel}` : ""}`}</h5>
              ) : (
                <h5>
                  {product.name}
                  <br></br>
                  {cfThirdPartyPromoLabel ? cfThirdPartyPromoLabel : ""}
                </h5>
              )}
            </div>
            <p className="right">{props.priceFormatter(changeFromBookingPrice)}</p>
          </div>
        </section>
        <section className="checkout-summary">
          <div className="empty-left">&#8203;</div>
          <div className="button-sector">
            <div className="current-payment">
              <p>{textKeys.subtotalText || "Subtotal"}</p>
              <p>{props.priceFormatter(bookingResultPrice)}</p>
            </div>
            <div className="previous-payment">
              <p>{textKeys.previousPayment || "Tidligere Betalt"}</p>
              <p>{props.priceFormatter(changeFromBookingPrice)}</p>
            </div>
            <div className="differential-payment">
              {/* if payment is 0 */}
              {totalpricedifference === 0 ? (
                <Fragment>
                  <div className="emphasized">{textKeys.totalSamePrice}</div>
                  <div className="emphasized">{props.priceFormatter(totalpricedifference)}</div>
                </Fragment>
              ) : (
                <Fragment>
                  {/* if payment < 0 */}
                  <div className="emphasized">{totalpricedifference > 0 ? textKeys.totalAdditivePrice : textKeys.totalNegativePrice}</div>
                  {/* if payment > 0 */}
                  <div className="emphasized">{props.priceFormatter(totalpricedifference)}</div>
                </Fragment>
              )}
            </div>
            {totalpricedifference === 0 ? (
              <div className="refund-info-text">
                <p>{textKeys.noAdditionalPayment || "Når du klikker gennemfør, ændres din booking & du modtager en ny ordrebekræftelse"}</p>
              </div>
            ) : (
              <Fragment>
                {totalpricedifference < 0 ? (
                  <div className="refund-info-text">
                    <p>{textKeys.refundMessage || "Penge refunderes tilbage til dit betalingskort indenfor 5 hverdage"}</p>
                  </div>
                ) : (
                  <div className="refund-info-text">
                    <p>{textKeys.additionalPayment || "Betalingen består af en ekstra-betaling minus din tidligere betaling"}</p>
                  </div>
                )}
              </Fragment>
            )}
            {/* removed due to https://alphasolutionsdk.atlassian.net/browse/PAR-3827 - if fix is ever requested, re-apply code & fix logic.
              {bookingHasPromotionDiscount ? (
                <div className="booking-discount-container">
                  <div className="booking-discount">
                    <p className="booking-discount-text">
                      {promotionDiscountText.formatUnicorn({ price: this.props.priceFormatter(bookingPromotionDiscountValue, true) })}
                    </p>
                  </div>
                </div>
              ) : hasActiveMembershipPrice ? (
                <div className="booking-discount-container">
                  <div className="booking-discount">
                    <p className="booking-discount-text">
                      {membershipDiscountText.formatUnicorn({ price: this.props.priceFormatter(membershipBookingPriceDifference, true) })}
                    </p>
                  </div>
                </div>
              ) : null}
              */}
          </div>
        </section>
      </section>
    </div>
  )
}
